import { cloneDeep } from 'lodash'
export const inputForm = cloneDeep({
  currentInsuranceAmount: '', // 社保养老金额
  currentRentAmount: '', // 房租可提供金额
  currentAnnuityAmount: '', // 年金可提供金额
  currentOtherAmount: '' // 其他收入可提供金额

})

// 底部按钮数组
export const btnList = cloneDeep([
  { name: '重置', btnType: 'reset' },
  { name: '确认', btnType: 'confirm' },
])

// 底部按钮数组
export const optBtnList = cloneDeep([
  { name: '养老需求测算', btnType: 'demand', path: '/pension/card/demand' },
  { name: '养老供给测算', btnType: 'supply', path: '/pension/card/supply' },
  // { name: '年金产品选择', btnType: 'productSelect', path: '' },
  { name: '年金产品选择', btnType: 'productSelect', path: '' },
  { name: '生成报告', btnType: 'report', path: '' }
])

export const supplyEnum = {
  age: '',
  insuranceAmount: '社保养老金额', // 社保养老金额
  rentAmount: '房租可提供金额', // 房租可提供金额
  annuityAmount: '年金可提供金额', // 年金可提供金额
  otherAmount: '其他收入可提供金额' // 其他收入可提供金额
}
